import { Form } from "formik";
import styled, { css } from "styled-components";
import { Select } from "antd";
import designSystemColors from "../../styles";
import { ClientSelectionItem } from "../ClientSelectionItem";

export const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  width: 100%;
  gap: 8px;
`;

export const ClientInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CustomClientSelectionItem = styled(ClientSelectionItem)`
  margin: 0;
  width: 100%;
  max-height: none;
`;

export const Label = styled.span`
  font-size: 14px;
  color: #00000085;
  font-weight: 300;
  letter-spacing: 0%;
`;

export const CustomSelect = styled(Select)`
  &.ant-select-disabled {
    .ant-select-selector {
      background: #ccc !important;
      opacity: 0.4 !important;
    }
  }

  &.error-id:not(.ant-select-disabled) {
    .ant-select-selector {
      border: 1px solid #ff4d4f !important;
    }
  }

  .ant-select-arrow {
    top: 50% !important;
  }
  .ant-select-selector {
    width: 100% !important;
    height: 43px !important;
    padding: 8px 12px !important;
    border-radius: 2px !important;
    border: 1px solid var(--neutral-5, #d9d9d9) !important;
    background: var(--neutral-color-gray-1, #fff);

    font-size: 16px;
    outline: 0;
    caret-color: #5188f4;
    color: #434343;

    &.error {
      border-color: #ff4d4f !important;
    }

    .ant-select-selection-placeholder {
      ${(props) =>
        props.disabled
          ? css`
              color: #434343 !important;
            `
          : css`
              color: #bfbfbf !important;
            `}
      font-weight: 400 !important;
    }
  }

  .ant-select-selection-search-input {
    height: 41px !important;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
  border-top: 1px solid ${designSystemColors.border.modalDivider};
  padding-top: 16px;

  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
